import { render, staticRenderFns } from "./PendingMediation.vue?vue&type=template&id=ace73596"
import script from "./PendingMediation.vue?vue&type=script&lang=js"
export * from "./PendingMediation.vue?vue&type=script&lang=js"
import style0 from "./PendingMediation.vue?vue&type=style&index=0&id=ace73596&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports